
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eticky-kodex-vzdelavania",
      function () {
        return require("private-next-pages/eticky-kodex-vzdelavania.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eticky-kodex-vzdelavania"])
      });
    }
  